/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetProduct200ResponseAllOfData } from './GetProduct200ResponseAllOfData';
import {
    GetProduct200ResponseAllOfDataFromJSON,
    GetProduct200ResponseAllOfDataFromJSONTyped,
    GetProduct200ResponseAllOfDataToJSON,
} from './GetProduct200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetProduct200ResponseAllOf
 */
export interface GetProduct200ResponseAllOf {
    /**
     * 
     * @type {GetProduct200ResponseAllOfData}
     * @memberof GetProduct200ResponseAllOf
     */
    data: GetProduct200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetProduct200ResponseAllOf interface.
 */
export function instanceOfGetProduct200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetProduct200ResponseAllOfFromJSON(json: any): GetProduct200ResponseAllOf {
    return GetProduct200ResponseAllOfFromJSONTyped(json, false);
}

export function GetProduct200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProduct200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetProduct200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetProduct200ResponseAllOfToJSON(value?: GetProduct200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetProduct200ResponseAllOfDataToJSON(value.data),
    };
}

